<template>
  <div class="promotion-page">
    <div class="page-header">
      <h2>ایجاد جشنواره جدید</h2>
    </div>

    <div class="form-card">
      <PromotionForm
          @success="onSuccess"
          @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import PromotionForm from './PromotionForm.vue';

export default {
  name: 'PromotionCreate',
  components: { PromotionForm },
  methods: {
    onSuccess() {
      this.$router.push('/dashboard/promotions/promotions');
    },
    onCancel() {
      this.$router.push('/dashboard/promotions/promotions');
    }
  }
};
</script>

<style scoped>
.promotion-page {
  padding: 20px;
}
.form-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.page-header h2 {
  color: #2c3e50;
  margin-bottom: 20px;
}
</style>